export function getFormattedLength(children: JSX.Element[] | JSX.Element): string {
  const itemsAmount = Array.isArray(children) && children.length > 1 ? children.length : 1;

  // TODO: Plural rules https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules
  if (itemsAmount > 1) {
    return `Comprando ${`0${itemsAmount}`.slice(-2)} itens`;
  }

  return `Comprando ${`0${itemsAmount}`.slice(-2)} item`;
}
